// extracted by mini-css-extract-plugin
export var circle = "_3e-2";
export var icon = "_3e-a";
export var iconHighlight = "_3e-0";
export var lg = "_3e-8";
export var md = "_3e-7";
export var outline = "_3e-4";
export var sm = "_3e-6";
export var square = "_3e-1";
export var xl = "_3e-9";
export var xs = "_3e-5";
export var xxs = "_3e-3";